import { MenuNavigate } from "@/components/elements/MenuNavigate";
import { TMenuContent } from "@/components/elements/MenuNavigate/MenuNavigate";
import { text } from "@/theme/colors";
import { layout } from "@/theme/variables";
import { Box, Stack, Typography } from "@mui/material";
import { FC, ReactNode } from "react";

type TDetailPageLayoutProps = {
  title: string;
  description: string;
  contents: TMenuContent[];
  footer: ReactNode;
  menuPrefix?: ReactNode;
};

export const DetailPageLayout: FC<TDetailPageLayoutProps> = ({ title, description, contents, footer, menuPrefix }) => {
  return (
    <Stack gap="24px" minHeight="calc(100vh - 105px)">
      <Stack width="100%" alignItems="center">
        <Stack width={layout.pageContentWidth} maxWidth="100%" gap="4px">
          <Typography variant="head20Bold" color={text.primary}>
            {title}
          </Typography>
          <Typography variant="body14" color={text.secondary}>
            {description}
          </Typography>
        </Stack>
      </Stack>

      <Stack flex={1} width="100%" alignItems="center">
        <Box width={layout.pageContentWidth} maxWidth="100%">
          <MenuNavigate menuPrefix={menuPrefix} contents={contents} />
        </Box>
      </Stack>

      <Stack width="100%" alignItems="center" sx={{ position: "sticky", bottom: 0, zIndex: 1 }}>
        <Box width={layout.pageContentWidth} maxWidth="100%">
          <Box pl={layout.menuNavigateOffset}>{footer}</Box>
        </Box>
      </Stack>
    </Stack>
  );
};
